import Vue from "vue";

export class NavbarView {
    public constructor() {
        this.SetupVue();
    }

    SetupVue() {
        let v = new Vue({
            el: "#navbar",
            data: {
                menu: {
                    open: false
                }
            }
        });
    }
}


// WEBPACK FOOTER //
// ./www/js/Pages/Shared/NavbarView.ts